import React, { useEffect, useState } from "react";
import { PendingIcon } from "../../../components/Icons";
import { SmallButton } from "../../../components/Buttons";
import { logout } from "../../../redux/actions/auth";
import { useDispatch } from "react-redux";
import LoadingModal from "../../../components/Modals/LoadingModal";
import { useNavigate } from "react-router-dom";
import { setPageTitle } from "../../../helper/metaDataHelper";

const PendingClient = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    setPageTitle("Pending Approval");
  }, []);

  const isloadingModal = (status) => {
    setisLoading(status);
    setIsModalOpen(status);
  };

  const handleLogout = async () => {
    isloadingModal(true);
    await dispatch(logout());
    isloadingModal(false);
    navigate("/signin");
  };

  return (
    <main>
      <div className="max-w-[1024px] mx-auto text-text-primary md:h-screen h-[80vh] overflow-scroll hide-scrollbar">
        <div className="inline-flex space-x-2 px-2 pb-8">
          <SmallButton onClick={handleLogout} text={"Logout"} cancel={true} />
        </div>
        <div className="md:py-16 py-10 space-y-6 bg-background-surface rounded-xl">
          <div className="flex  justify-center items-center ">
            <PendingIcon className="w-40 h-40" />
          </div>
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-2xl font-bold text-center">
              Your account is pending approval
            </h1>
            <p className="text-center mt-4 md:px-40">
              Please note that your account registration is currently pending
              approval. Our team will review your application, and once
              approved, you'll have full access to our services.
            </p>
          </div>
        </div>
      </div>
      <LoadingModal
        isLoading={isLoading}
        setisLoading={setisLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </main>
  );
};

export default PendingClient;
